import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { RoleSelection } from './pages/RoleSelection';
import { CreatorDashboard } from './pages/CreatorDashboard';
import { CreatorCampaignsPage } from './pages/CreatorCampaignsPage';
import { CreatorDeliverablesPage } from './pages/CreatorDeliverablesPage';
import { CreatorTasksPage } from './pages/CreatorTasksPage';
import { CreatorBrandsPage } from './pages/CreatorBrandsPage';
import { ManagerDashboard } from './pages/ManagerDashboard';
import { ManagerProfilePage } from './pages/ManagerProfilePage';
import { ChatPage } from './pages/ChatPage';
import { LoginPage } from './pages/LoginPage';
import { SignupPage } from './pages/SignupPage';
import { APIConnectionPage } from './pages/APIConnectionPage';
import { BrandsPage } from './pages/BrandsPage';
import { ProjectsPage } from './pages/ProjectsPage';
import { ProjectDetailPage } from './pages/ProjectDetailPage';
import { TasksPage } from './pages/TasksPage';
import { CreatorsPage } from './pages/CreatorsPage';
import { CreatorDetailPage } from './pages/CreatorDetailPage';
import { CalendarPage } from './pages/CalendarPage';
import { PlatformsPage } from './pages/PlatformsPage';
export function App() {
  return <AuthProvider data-id="element-0">
      <Router data-id="element-1">
        <Routes data-id="element-2">
          {/* All routes now public for demo */}
          <Route path="/" element={<RoleSelection data-id="element-4" />} data-id="element-3" />
          <Route path="/login" element={<LoginPage data-id="element-6" />} data-id="element-5" />
          <Route path="/signup" element={<SignupPage data-id="element-8" />} data-id="element-7" />

          {/* Creator Routes */}
          <Route path="/creator" element={<CreatorDashboard data-id="element-10" />} data-id="element-9" />
          <Route path="/creator/campaigns" element={<CreatorCampaignsPage data-id="element-12" />} data-id="element-11" />
          <Route path="/creator/deliverables" element={<CreatorDeliverablesPage data-id="element-14" />} data-id="element-13" />
          <Route path="/creator/tasks" element={<CreatorTasksPage data-id="element-16" />} data-id="element-15" />
          <Route path="/creator/brands" element={<CreatorBrandsPage data-id="element-18" />} data-id="element-17" />
          <Route path="/creator/connect-api" element={<APIConnectionPage data-id="element-20" />} data-id="element-19" />

          {/* Manager Routes */}
          <Route path="/manager" element={<ManagerDashboard data-id="element-22" />} data-id="element-21" />
          <Route path="/manager/profile" element={<ManagerProfilePage data-id="element-24" />} data-id="element-23" />
          <Route path="/manager/creators" element={<CreatorsPage data-id="element-26" />} data-id="element-25" />
          <Route path="/manager/creators/:id" element={<CreatorDetailPage data-id="element-28" />} data-id="element-27" />
          <Route path="/manager/brands" element={<BrandsPage data-id="element-30" />} data-id="element-29" />
          <Route path="/manager/projects" element={<ProjectsPage data-id="element-32" />} data-id="element-31" />
          <Route path="/manager/projects/:id" element={<ProjectDetailPage data-id="element-34" />} data-id="element-33" />
          <Route path="/manager/tasks" element={<TasksPage data-id="element-36" />} data-id="element-35" />
          <Route path="/manager/calendar" element={<CalendarPage data-id="element-38" />} data-id="element-37" />
          <Route path="/manager/platforms" element={<PlatformsPage data-id="element-40" />} data-id="element-39" />

          <Route path="/chat" element={<ChatPage data-id="element-42" />} data-id="element-41" />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace data-id="element-44" />} data-id="element-43" />
        </Routes>
      </Router>
    </AuthProvider>;
}